import React from 'react';
import { BringzzIcon, BringzzText } from "@bringzz/components";

const EmptyState = () => {
    return (
        <div className="text-center py-8">
            <BringzzIcon
                size="48"
                icon="IconBellRinging"
                folder="LineIcons"
                className="mx-auto mb-4 text-gray-400"
            />
            <BringzzText tag='h4' className="text-gray-500 mb-2">
                No notifications yet
            </BringzzText>
        </div>
    );
};

export default EmptyState;
